import { render, staticRenderFns } from "./JointsConfiguratorTemplate.vue?vue&type=template&id=0d25267b&scoped=true"
import script from "./JointsConfiguratorTemplate.vue?vue&type=script&setup=true&lang=ts"
export * from "./JointsConfiguratorTemplate.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./JointsConfiguratorTemplate.vue?vue&type=style&index=0&id=0d25267b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d25267b",
  null
  
)

export default component.exports